module.exports = __webpack_public_path__ + "img/birthday-tag.c9a8c89a.svg";